import styled from 'styled-components'

const toDimension = (val) => {
  if (val == null) return null
  return typeof val === 'number' ? `${val}px` : val
}

export const SkeletonBox = styled.div`
  background: var(--vo-cloud);
  border-radius: var(--radius-md);
  animation: pulse 1.5s infinite;
  width: ${({ $width }) => toDimension($width) || '100%'};
  height: ${({ $height }) => toDimension($height) || '20px'};
  margin-bottom: ${({ $marginBottom }) => ($marginBottom != null ? `${$marginBottom}px` : '0')};

  @keyframes pulse {
    0%, 100% { opacity: 0.4; }
    50% { opacity: 0.8; }
  }
`
